/**
 * NỘI DUNG TRANG CÔNG CỤ TẠO VIDEO HÀNG LOẠT (/tools/tao-video-hang-loat)
 *
 * Toàn bộ chữ trên trang lấy từ file này — sửa nội dung chỉ cần sửa ở đây.
 * Trường để trống ('' hoặc []) thì trang tự ẩn phần tương ứng.
 *
 * File zip nằm trên máy chủ (web/back-end/storage/tools). Người đã đăng nhập bấm tải thì API cấp link tạm
 * có hạn 5 phút (GET /pharmacy-tool/video-tool/download → /video-tool/file?t=...).
 *
 * published: false  → thẻ công cụ ở /tools chỉ hiện với ADMIN, trang hiện dải "bản nháp".
 * published: true   → hiện cho mọi người.
 */
export const VIDEO_BATCH_TOOL = {
  published: true,

  slug: 'tao-video-hang-loat',
  // Tên file này, hiện trong dải "bản nháp" để ADMIN biết sửa ở đâu
  contentFile: 'videoBatchToolContent.js',
  name: 'Công Cụ Tạo Video Hàng Loạt',
  tagline: 'Ghép hàng loạt ảnh infographic vào video nền, ra hàng trăm video dọc TikTok / Reels ngay trên máy tính',
  intro:
    'Chuẩn bị sẵn ảnh .png (mỗi ảnh là một video) và các video nền .mp4, bấm chạy là công cụ tự ghép từng ảnh vào giữa video nền, ' +
    'xuất ra video dọc đặt tên trùng tên ảnh. Mỗi video mất khoảng 15–25 giây; 200+ video khoảng 60–80 phút, cứ để máy tự chạy. ' +
    'Công cụ do Thế Thảo Pharma xây dựng cho nhà thuốc, giá 50.000đ dùng 12 tháng.',
  // Phiên bản hiện trên trang. File zip trên máy chủ: web/back-end/storage/tools (khai báo ở pharmacy-tool.controller.js, VIDEO_TOOL)
  version: '1.3',
  fileSize: '',
  updatedAt: '08/10/2026',
  platforms: ['Windows 10/11 (64-bit)', 'macOS 11 trở lên (chip Apple hoặc Intel)'],
  image: '/images/tools/tool-tao-video-hang-loat-v2.jpg',
  heroBanner: '/images/tools/tool-tao-video-hang-loat-v2.jpg',

  // Ô nổi bật ở phần đầu trang
  highlights: [
    { value: '200+', label: 'video trong khoảng 60–80 phút' },
    { value: '4 GB', label: 'RAM là chạy mượt' },
    { value: '50.000đ', label: 'dùng 12 tháng, tải về nhiều lần' },
  ],

  features: [
    { title: 'Ghép ảnh vào video nền hàng loạt', desc: 'Mỗi ảnh .png thành một video dọc, ảnh đặt giữa khung, tên video trùng tên ảnh để dễ quản lý.' },
    { title: 'Tự luân phiên các video nền', desc: 'Ảnh 1 dùng nền 1, ảnh 2 dùng nền 2… hết nền thì quay lại từ đầu, video không bị trùng nhau.' },
    { title: 'Chạy lại làm tiếp phần còn dở', desc: 'Lỡ tắt máy giữa chừng thì chạy lại: video đã tạo được bỏ qua, chỉ làm phần còn thiếu.' },
    { title: 'Tùy chỉnh dễ', desc: 'Đổi cỡ ảnh trong khung, độ nặng file video, thư mục lưu — sửa một con số hoặc kéo thả thư mục.' },
  ],

  audience: [
    'Chủ nhà thuốc tự làm nội dung Facebook, TikTok, Zalo',
    'Nhân viên marketing chuỗi nhà thuốc cần ra nhiều video mỗi tuần',
  ],

  requirements: [
    { label: 'Hệ điều hành', value: 'Windows 10/11 (64-bit), hoặc macOS 11 trở lên — máy Mac chip Apple (M1, M2, M3…) hay chip Intel đều được' },
    { label: 'RAM', value: 'Tối thiểu 4 GB' },
    { label: 'Ổ cứng trống', value: 'Tối thiểu 500 MB (chưa tính dung lượng video tạo ra)' },
    { label: 'Internet', value: 'Chỉ cần ở lần cài đầu tiên (tự tải phần mềm xử lý video ffmpeg, khoảng 90–150 MB). Sau đó chạy không cần mạng' },
    { label: 'Chuẩn bị', value: 'Ảnh infographic .png khung dọc 9:16 và các video nền khung dọc 9:16 dạng .mp4' },
  ],

  // Các bước cài đặt trên Windows. `tip` (tuỳ chọn) hiện dạng ghi chú nhỏ dưới bước.
  installSteps: [
    {
      title: 'Tải và giải nén',
      desc: 'Bấm "Tải công cụ" (cần đăng nhập) để tải file zip. Chuột phải vào file → "Extract All…" (Giải nén tất cả), chọn thư mục dễ tìm như Desktop. Trong thư mục có 2 file BUOC 1, BUOC 2, file HUONG DAN.txt và 3 thư mục anh, nen, video.',
      tip: 'Không chạy file bên trong file zip — phải giải nén ra trước.',
    },
    {
      title: 'Cài đặt — chạy một lần duy nhất',
      desc: 'Bấm đúp "BUOC 1 - CAI DAT.bat". Công cụ tự tải phần mềm xử lý video ffmpeg (khoảng 90–150 MB) về thư mục công cụ, mất vài phút tùy tốc độ mạng. Thấy "CAI DAT XONG - MAY DA SAN SANG" là xong.',
      tip: 'Trong lúc tải, màn hình đứng im — đừng tắt cửa sổ. Nếu Windows hiện "Windows protected your PC": bấm "More info" → "Run anyway".',
    },
    {
      title: 'Chuẩn bị ảnh và video nền (khung dọc 9:16)',
      desc: 'Chép các video nền .mp4 khung dọc 9:16 vào thư mục "nen" và toàn bộ ảnh .png khung dọc 9:16 vào thư mục "anh". Đặt tên ảnh theo thứ tự, ví dụ "001. 7 cau hoi vang can hoi khach.png".',
    },
    {
      title: 'Tạo video',
      desc: 'Bấm đúp "BUOC 2 - TAO VIDEO.bat". Công cụ chạy lần lượt từng video; xong sẽ báo tổng số video tạo mới, bỏ qua, lỗi. Video nằm trong thư mục "video", tên trùng tên ảnh.',
      tip: 'Muốn lưu thẳng sang thư mục khác: kéo thả thư mục đó vào file "BUOC 2 - TAO VIDEO.bat".',
    },
  ],

  // Các bước cài đặt trên macOS (2 file .command trong cùng file zip)
  installStepsMac: [
    {
      title: 'Tải và giải nén',
      desc: 'Bấm "Tải công cụ" (cần đăng nhập). Mở thư mục Downloads (Tải về), bấm đúp file zip để giải nén, kéo thư mục "TAO VIDEO - The Thao Pharma" ra Desktop cho dễ tìm. Bản Mac dùng 2 file có chữ (MAC).',
    },
    {
      title: 'Cài đặt — chạy một lần duy nhất',
      desc: 'Chuột phải (hoặc giữ Control + bấm) vào "BUOC 1 - CAI DAT (MAC).command" → chọn "Mở" (Open) → bấm "Mở" ở hộp thoại. Cửa sổ Terminal hiện ra và tự tải ffmpeg (khoảng 25–30 MB). Thấy "CAI DAT XONG - MAY DA SAN SANG" là xong.',
      tip: 'macOS chặn file tải từ Internet nên lần đầu phải mở bằng chuột phải → Mở. Nếu hộp thoại không có nút Mở: vào Cài đặt hệ thống → Quyền riêng tư & Bảo mật → bấm "Vẫn mở" (Open Anyway), rồi mở lại file.',
    },
    {
      title: 'Chuẩn bị ảnh và video nền (khung dọc 9:16)',
      desc: 'Chép các video nền .mp4 khung dọc 9:16 vào thư mục "nen" và toàn bộ ảnh .png khung dọc 9:16 vào thư mục "anh". Đặt tên ảnh theo thứ tự, ví dụ "001. 7 cau hoi vang can hoi khach.png".',
    },
    {
      title: 'Tạo video',
      desc: 'Mở "BUOC 2 - TAO VIDEO (MAC).command" (lần đầu cũng chuột phải → Mở). Công cụ chạy lần lượt từng video, xong tự mở thư mục "video".',
      tip: 'Muốn lưu sang thư mục khác: mở file BUOC 2 (MAC) bằng TextEdit, điền đường dẫn vào dòng OUT_DIR="".',
    },
  ],

  // Video hướng dẫn trên YouTube (chỉ điền phần ID, ví dụ 'dQw4w9WgXcQ'). Để trống thì ẩn khung video.
  youtubeVideoId: '',

  faqs: [
    {
      q: 'Công cụ có mất phí không?',
      a: 'Giá 50.000đ, dùng 12 tháng, tải về nhiều lần. Đăng nhập tài khoản daotaonhathuoc.com, thanh toán bằng QR chuyển khoản là mở tải ngay.',
    },
    {
      q: 'Có cần cài thêm phần mềm nào không?',
      a: 'Không phải tự cài. Lần đầu chạy "BUOC 1 - CAI DAT.bat", công cụ tự tải phần mềm xử lý video ffmpeg về (cần Internet). Từ lần sau không cần mạng nữa.',
    },
    {
      q: 'Bước 1 báo không tải được ffmpeg?',
      a: 'Thường do mạng công ty chặn tải file. Công cụ sẽ mở trang tải ffmpeg: tải file ffmpeg-release-essentials.zip, giải nén, chép file ffmpeg.exe trong thư mục bin vào thư mục công cụ rồi chạy lại Bước 1. Hoặc xin file ffmpeg.exe từ một máy đã cài được và chép vào.',
    },
    {
      q: 'Bước 2 báo "Khong tim thay ffmpeg"?',
      a: 'Máy chưa cài xong Bước 1. Chạy lại "BUOC 1 - CAI DAT.bat" — Bước 2 cũng tự hỏi có muốn chạy Bước 1 ngay không.',
    },
    {
      q: 'Muốn ảnh to / nhỏ hơn trong khung, hoặc video nhẹ hơn?',
      a: 'Mở "BUOC 2 - TAO VIDEO.bat" bằng Notepad. Sửa dòng set "PHANTRAM=80" (ảnh chiếm 80% bề ngang; đổi 75, 85…). Muốn file nhẹ hơn: sửa set "CRF=23" thành 26 hoặc 28 (số càng lớn file càng nhẹ, chất lượng giảm).',
    },
    {
      q: 'Tắt máy giữa chừng hoặc vài video báo lỗi?',
      a: 'Chạy lại "BUOC 2 - TAO VIDEO.bat": video đã tạo xong được bỏ qua, công cụ chỉ làm lại những video còn thiếu hoặc lỗi.',
    },
    {
      q: 'Chữ tiếng Việt trên cửa sổ bị lỗi font?',
      a: 'Không sao, chỉ là hiển thị trên cửa sổ đen. File video vẫn tạo đúng tên.',
    },
    {
      q: 'Máy Mac có dùng được không?',
      a: 'Được. File zip có sẵn 2 file cho Mac: "BUOC 1 - CAI DAT (MAC).command" và "BUOC 2 - TAO VIDEO (MAC).command". Xem tab macOS ở phần hướng dẫn cài đặt.',
    },
    {
      q: 'Mac báo "không thể mở vì từ nhà phát triển không xác định" hoặc "không đủ quyền"?',
      a: 'Lần đầu mở file .command: chuột phải → Mở → Mở. Nếu vẫn chặn: Cài đặt hệ thống → Quyền riêng tư & Bảo mật → "Vẫn mở". Nếu báo không đủ quyền (permission denied): mở Terminal, gõ chmod +x (có dấu cách), kéo thả file .command vào rồi bấm Enter.',
    },
  ],

  support: {
    text: 'Cài đặt gặp khó khăn? Gọi hoặc nhắn Zalo đội hỗ trợ kèm ảnh chụp màn hình lỗi.',
    phone: '0812539539',
    phoneLabel: '0812.539.539',
  },
};
